// extracted by mini-css-extract-plugin
module.exports = {"link":"_99551c8aa8--link--WPctq"};